import { HStack, Progress, Text, VStack } from '@chakra-ui/react';
import { AiIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { ReactElement } from 'react';

type Props = {
  actionLabel: string;
  progress: number;
  progressMessage: string;
};

export const WorksheetFeedbackSummaryProgress = ({
  actionLabel,
  progress,
  progressMessage,
}: Props): ReactElement => {
  return (
    <VStack align="stretch" gap="xs" width="100%">
      <HStack gap="xs" align="center">
        <NovaIcon icon={AiIcon} size="s" aria-hidden color="icon.primary" />
        <Text textStyle="body.m.regular" color="text.primary">
          {actionLabel}
        </Text>
      </HStack>

      <VStack
        align="stretch"
        gap="2xs"
        width="100%"
        bg="background.primary"
        py="2xs"
        borderRadius="m"
      >
        <Progress.Root value={progress} size="sm" colorPalette="green" borderRadius="full" animated>
          <Progress.Track bg="progress.background">
            <Progress.Range />
          </Progress.Track>
        </Progress.Root>
        <Text textStyle="body.xs.regular" color="text.primary">
          {progressMessage} ({progress}%)
        </Text>
      </VStack>
    </VStack>
  );
};
